<template>
	<div>
		<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel" class="dialog_form">
			<el-form-item v-for="(item,index) in dialog_span" :key="index" :label="item.name" :prop="item.model">
				<el-input v-model="inputmodel[`${item.model}`]" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="上级分类" prop="type"><br>
				<el-select style="width: 100%;" v-model="inputmodel.type" placeholder="请选择优惠券种类"
					v-el-select-loadmore="loadmore">
					<el-option v-for=" item in options" :key="item.id" :label="item.name" :value="item.name">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="日期" prop="time"><br>
				<el-date-picker style="width: 100%;" v-model="inputmodel.time" type="date" placeholder="选择日期"
					format="yyyy 年 MM 月 dd 日" value-format="yyyy/MM/dd">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="缩略图" prop="house_number"><br>
				<el-upload class="upload-demo" ref="upload" action="https://jsonplaceholder.typicode.com/posts/"
					:on-preview="handlePreview" :on-remove="handleRemove" :on-change="uploadChange" :file-list="ruleForm.file"
					:auto-upload="false">
					<div style="display: flex;justify-content: space-between; width: 100%;">
						<el-button slot="trigger" size="small" type="primary" plain>
							<i class="el-icon-upload"></i>
							选取文件
						</el-button>
					</div>
				</el-upload>
			</el-form-item>
			<el-form-item label="状态" prop="status"><br>
				<el-radio v-model="inputmodel.status" :label="1">启用</el-radio>
				<el-radio v-model="inputmodel.status" :label="0">禁用</el-radio>
			</el-form-item>

		</el-form>
		<div style="width: 100%;height: 100%;">
			<quill-editor class="ql-editor" v-model="inputmodel.introduce" ref="myQuillEditor" :options="editorOption"
				@blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @change="onEditorChange($event)" style="">
			</quill-editor>
			<!-- 		<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea">
			</el-input> -->
		</div>
		<!-- 		<div style="border: 1px solid #ccc;">
			<Toolbar style="" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
			<Editor style="height: 500px; overflow-y: hidden;" v-model="html" :defaultConfig="editorConfig" :mode="mode"
				@onCreated="onCreated" />
		</div> -->
		<div class="bottom_button">
			<el-button @click="qx(1)">取 消</el-button>
			<el-button type="primary" @click="qx()">确 定</el-button>
		</div>
	</div>
</template>

<script>
	import {
		up_img,
		couponspecies_list,
		activity_create
	} from "@/api/api.js"
	import {
		Editor,
		Toolbar
	} from '@wangeditor/editor-for-vue'

	export default {
		directives: {
			'el-select-loadmore': {
				bind(el, binding) {
					const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
					SELECTWRAP_DOM.addEventListener('scroll', function() {
						const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
						if (condition) {
							binding.value();
						}
					});
				}
			}
		},
		data() {
			return {
				name: '',
				dialog_span: [{
					name: '活动名称',
					model: 'name'
				}, {
					name: '地址',
					model: 'address'
				}],
				inputmodel: {
					name: '',
					type: '',
					address: '',
					time: '',
					status: '',
					introduce: ''
				},
				rules: {},
				options: [],
				formData: {
					page: 1,
					limit: 10
				},
				value2: '',
				checked: '',
				content: '',
				ruleForm: {
					file: [],
				},
				wenjian1: '',
				editor: null,
				html: '',
				toolbarConfig: {},
				editorConfig: {
					placeholder: '请输入内容...'
				},
				mode: 'default', // or 'simple'
				// 富文本编辑器配置
				editorOption: {
					modules: {
						toolbar: {
							container: [
								['bold', 'italic', 'underline', 'strike'], // 加粗 斜体 下划线 删除线
								['blockquote', 'code-block'], // 引用  代码块
								[{
									header: 1
								}, {
									header: 2
								}], // 1、2 级标题
								[{
									list: 'ordered'
								}, {
									list: 'bullet'
								}], // 有序、无序列表
								[{
									script: 'sub'
								}, {
									script: 'super'
								}], // 上标/下标
								[{
									indent: '-1'
								}, {
									indent: '+1'
								}], // 缩进
								[{
									direction: 'rtl'
								}], // 文本方向
								[{
									size: ['12px', false, '16px', '18px', '20px', '30px']
								}], // 字体大小
								[{
									header: [1, 2, 3, 4, 5, 6, false]
								}], // 标题
								[{
									color: []
								}, {
									background: []
								}], // 字体颜色、字体背景颜色
								[{
									font: [false, 'SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial']
								}], // 字体种类
								[{
									align: []
								}], // 对齐方式
								['clean'], // 清除文本格式
								['image']
							], // 工具栏

							imageResize: { //添加
								displayStyles: { //添加
									backgroundColor: 'black',
									border: 'none',
									color: 'white'
								},
								modules: ['Resize', 'DisplaySize', 'Toolbar'] //添加
							}
						}
					},
					placeholder: '请输入正文'
				},
			}
		},
		methods: {
			qx(i) {
				console.log(this.inputmodel);
				if (i != 1) {
					if (this.wenjian1 == '') {
						this.$message({
							message: '请选择缩略图',
							type: 'error'
						});
					}
					setTimeout(() => {
						if (this.inputmodel.introduce == '') {
							this.$message({
								message: '请填写活动介绍',
								type: 'error'
							});
						}
					}, 1000);

					console.log('this.wenjian1', this.wenjian1);
					const formData = new FormData()
					formData.append('image', this.wenjian1)

					this.$refs['inputmodel'].validate((valid) => {
						if (valid) {
							up_img(formData).then(res => {
								console.log(res);
								this.inputmodel.aid = res.data.id
								this.inputmodel.dir = res.data.dir
								activity_create(this.inputmodel).then(res => {
									this.Messages(res)
									if (res.status == 200) {
										this.inputmodel = {}
										this.$emit('changedia', false)
										this.$parent.$parent.$parent.contractlistcontractlist();
									}
								})
							})

						}
					})
				} else {
					this.inputmodel = {}
					this.$emit('changedia', false)
				}
			},
			loadmore() {
				console.log(this.formData.limit);
				this.formData.page++;
				let sum = this.formData.limit
				// this.formData.limit = sum - (10 * (this.formData.page - 1))
				// if (this.formData.limit >= 0) {
				this.getList(this.formData);
				// }
				// console.log(this.formData);
			},
			getList(formData) {
				couponspecies_list(formData).then(res => {
					const _res = res.data.list
					this.options = [...this.options, ..._res];
				})

			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			},
			// 失去焦点事件
			onEditorBlur(quill) {
				console.log('editor blur!', quill)
			},
			// 获得焦点事件
			onEditorFocus(quill) {
				console.log('editor focus!', quill)
			},
			// 准备富文本编辑器
			onEditorReady(quill) {
				console.log('editor ready!', quill)
			},
			// 内容改变事件
			onEditorChange({
				quill,
				html,
				text
			}) {
				console.log('editor change!', quill, html, text)
				this.inputmodel.introduce = html

			},
			handleRemove(file, fileList) {
				this.wenjian1 = ''
			},
			handlePreview(file) {
				// console.log(file)
				console.log('点击', this.ruleForm.file)
			},
			uploadChange(file, fileList) {
				// 验证文件数量，替换后仅保留第一个文件
				if (fileList.length > 1) {
					fileList.splice(0, 1)
					console.log('文件1', fileList)
				}
				this.ruleForm.file = fileList
				this.wenjian1 = file.raw
				console.log('this.ruleForm.file', this.ruleForm.file);
			},
			onCreated(editor) {
				this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
			},

		},
		created() {
			for (let item in this.inputmodel) {
				this.rules[`${item}`] = [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}]
			};
			couponspecies_list().then(res => {
				const _res = res.data.list
				this.options = _res;
			})
		},
		components: {
			Editor,
			Toolbar
		},
		beforeDestroy() {
			const editor = this.editor
			if (editor == null) return
			editor.destroy() // 组件销毁时，及时销毁编辑器
		}
	}
</script>

<style scoped>
	.dialog_form {
		display: grid;
		grid-template-columns: auto auto;
		grid-column-gap: 0.5rem;
		grid-auto-flow: row dense;
	}

	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}

	.upload-demo {
		display: flex;
		align-items: center !important;

	}
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>